import { render, staticRenderFns } from "./VehicleStatus.vue?vue&type=template&id=2e6c2583&scoped=true&"
import script from "./VehicleStatus.vue?vue&type=script&lang=js&"
export * from "./VehicleStatus.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatus.vue?vue&type=style&index=0&id=2e6c2583&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c2583",
  null
  
)

export default component.exports